import { gql } from "@apollo/client";

const GENERATE_PASSWORD = gql`
  mutation GENERATE_PASSWORD($input: OtpInput!) {
    otp(input: $input) {
      data
      status
      error
    }
  }
`;
export default GENERATE_PASSWORD;
